import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useCallback } from 'react'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import PageData from '@v4/utils/data/PageData'
import useStyles from './EmptyMainSection.styled'

export const useEmptyMainSection = ({ pageType }) => {
	const { setSidebarMode } = PageBuilderSelector.useActions()
	const sectionLabel = PageData.getSectionLabel(pageType)
	const pageLabel = PageData.getPageLabel(pageType)
	const classes = useStyles()

	const handleAddSection = useCallback(() => setSidebarMode(PageBuilderModel.SIDEBAR_MODE.ADDITION), [setSidebarMode])

	return [
		{
			classes,
			text: `Click to add your first ${sectionLabel} and start creating your ${pageLabel}`,
			buttonLabel: `Add ${sectionLabel}`,
		},
		{ handleAddSection },
	]
}
